/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { SheetId } from "../../commons/types/SheetId";
import { WorkbookId } from "../../commons/types/WorkbookId";
import { SheetConfig } from "./SheetConfig";
export const SheetUpdate = core.serialization.object({
    id: SheetId.optional(),
    workbookId: WorkbookId.optional(),
    config: SheetConfig.optional(),
    metadata: core.serialization.any().optional(),
    namespace: core.serialization.string().optional(),
    updatedAt: core.serialization.date().optional(),
    createdAt: core.serialization.date().optional(),
});
